import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import {
  BackButton,
  Footer,
  Header,
  Page,
  PageContent,
} from "@/components/page.tsx";
import { useAudioSlot } from "@/features/audio/kiosk-audio";
import {
  CouponCodeForm,
  CouponHelpText,
} from "@/features/coupons/coupon-code-form";

export const Route = createFileRoute(
  "/coupon-screen/{-$machineId}/{-$dryerBundleId}",
)({
  component: RouteComponent,
  params: {
    parse: (params) =>
      z
        .object({
          machineId: z.coerce.number().optional(),
          dryerBundleId: z.coerce.number().optional(),
        })
        .parse(params),
  },
});

function RouteComponent() {
  useAudioSlot("page.coupon");
  const { machineId, dryerBundleId } = Route.useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigateBack = () =>
    machineId
      ? navigate({
          to: `/payment-selector-screen/$machineId/{-$dryerBundleId}`,
          params: { machineId, dryerBundleId },
        })
      : navigate({ to: `/machine-type-selector-screen` });

  return (
    <Page>
      <Header
        backArrowHref={
          <BackButton label={t("Vissza")} onClick={navigateBack} />
        }
      />
      <PageContent>
        <CouponCodeForm
          machineId={machineId}
          dryerBundleId={dryerBundleId}
          onApplied={navigateBack}
        />
        <Footer helpText={<CouponHelpText />} />
      </PageContent>
    </Page>
  );
}
